/* FAQ Section – Sacred Modern Design
 * Light section with accordion FAQ
 * Uses Radix Accordion component
 */
import { FAQ_ITEMS } from "@/lib/constants";
import { useScrollAnimation } from "@/hooks/useScrollAnimation";
import { useI18n } from "@/contexts/I18nContext";
import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from "@/components/ui/accordion";

export default function FaqSection() {
  const { t } = useI18n();
  const { ref, isVisible } = useScrollAnimation();

  return (
    <section id="faq" className="section-light py-24 lg:py-32 relative" ref={ref}>
      <div className="gold-line w-full absolute top-0" />

      <div className="container">
        <div
          className={`text-center max-w-3xl mx-auto mb-16 transition-all duration-700 ${
            isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8"
          }`}
        >
          <span className="text-sm font-semibold tracking-[0.2em] uppercase text-[oklch(0.52_0.09_128)]" style={{ fontFamily: "var(--font-body)" }}>
            {t("landing.faq.badge")}
          </span>
          <h2 className="text-3xl sm:text-4xl lg:text-5xl font-bold text-[oklch(0.25_0.04_50)] mt-4 mb-6">
            {t("landing.faq.heading1")} <span className="text-[oklch(0.52_0.09_128)]">{t("landing.faq.heading2")}</span>
          </h2>
        </div>

        <div
          className={`max-w-3xl mx-auto transition-all duration-700 delay-200 ${
            isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8"
          }`}
        >
          <Accordion type="single" collapsible className="space-y-4">
            {FAQ_ITEMS.map((item, i) => (
              <AccordionItem
                key={i}
                value={`item-${i}`}
                className="bg-white rounded-xl border border-[oklch(0.88_0.02_80)] px-6 shadow-sm data-[state=open]:shadow-md data-[state=open]:border-[oklch(0.52_0.09_128/0.3)] transition-all duration-300"
              >
                <AccordionTrigger className="text-left text-[oklch(0.25_0.04_50)] font-semibold hover:text-[oklch(0.52_0.09_128)] py-5 text-base [&[data-state=open]]:text-[oklch(0.52_0.09_128)]">
                  {t(item.questionKey as any)}
                </AccordionTrigger>
                <AccordionContent className="text-[oklch(0.5_0.03_50)] leading-relaxed pb-5" style={{ fontFamily: "var(--font-body)" }}>
                  {t(item.answerKey as any)}
                </AccordionContent>
              </AccordionItem>
            ))}
          </Accordion>
        </div>
      </div>
    </section>
  );
}
